export default "https://chowbus-web-static.chowbus.com/_next/static/chunks/proximanova-regular-webfont-9ed89f1472769534ed39485fdfb2d12f.woff";